import { Directive, ElementRef, HostListener, Injectable, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

type IKNOWISNUMBER = any;
type IKNOWISSTRING = any;

@Injectable({
  providedIn: 'root',
})
export class TabService {
  selectedInput: BehaviorSubject<number> = new BehaviorSubject<number>(1);
}

@Directive({
  selector: 'input[tabindex][enterToTab]',
})
export class EnterToTabDirective {
  private _index: number = 0;
  private _nextIndex: number | null = null;
  get index(): IKNOWISNUMBER {
    return this._index;
  }

  @Input('tabindex')
  set index(value: IKNOWISSTRING) {
    this._index = parseInt(value);
  }

  get nextIndex(): IKNOWISNUMBER {
    return this._nextIndex;
  }

  @Input('enterToTab')
  set nextIndex(value: IKNOWISSTRING) {
    if (value) {
      this._nextIndex = parseInt(value);
    }
  }

  @HostListener('keydown', ['$event'])
  onInput(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      this.tabService.selectedInput.next(this.nextIndex!);
      e.preventDefault();
    }
  }

  constructor(private element: ElementRef, private tabService: TabService) {}

  ngOnInit() {
    if (this.nextIndex === null) {
      this.nextIndex = this.index + 1;
    }

    this.tabService.selectedInput.subscribe((i: number) => {
      if (i === this.index) {
        this.element.nativeElement.focus();
        this.element.nativeElement.select();
      }
    });
  }
}
